/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Eudirective21Inputs */

const id_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan dan Jawaban – Aturan hak cipta UE baru`)
};

const ms_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soalan dan Jawapan – Peraturan hak cipta EU baharu`)
};

const da_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spørgsmål og svar – Nye EU-ophavsretsregler`)
};

const de_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen und Antworten – Neue EU-Urheberrechtsregeln`)
};

const en_us2_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions and Answers – New EU copyright rules`)
};

const es_es2_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas y respuestas – Nuevas normas de derechos de autor de la UE`)
};

const es_mx2_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas y respuestas – Nuevas normas de derechos de autor de la UE`)
};

const fil_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tanong at Sagot – Mga bagong panuntunan sa copyright ng EU`)
};

const fr_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions et réponses — Nouvelles règles européennes sur le droit d'auteur`)
};

const it_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande e risposte – Nuove norme UE sul copyright`)
};

const hu_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérdések és válaszok – Új EU-s szerzői jogi szabályok`)
};

const nl_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragen en antwoorden – Nieuwe EU-auteursrechtregels`)
};

const no_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spørsmål og svar – Nye EU-regler for opphavsrett`)
};

const pl_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytania i odpowiedzi – Nowe unijne przepisy dotyczące praw autorskich`)
};

const pt_br2_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas e Respostas – Novas regras de direitos de autor da UE`)
};

const pt_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas e Respostas – Novas regras de direitos de autor da UE`)
};

const ro_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Întrebări și răspunsuri – Noile norme UE privind drepturile de autor`)
};

const fi_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kysymyksiä ja vastauksia – Uudet EU:n tekijänoikeussäännöt`)
};

const sv_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frågor och svar – Nya EU-regler om upphovsrätt`)
};

const vi_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỏi và Đáp – Các quy tắc bản quyền mới của EU`)
};

const tr_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorular ve Cevaplar – Yeni AB telif hakkı kuralları`)
};

const cs_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otázky a odpovědi – Nová pravidla EU pro autorská práva`)
};

const bg_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Въпроси и отговори – Нови правила на ЕС за авторското право`)
};

const ru_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы и ответы — Новые правила ЕС по авторскому праву`)
};

const uk_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запитання та відповіді – Нові правила ЄС щодо авторського права`)
};

const ar_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسئلة وأجوبة – قواعد حقوق الطبع والنشر الجديدة للاتحاد الأوروبي`)
};

const hi_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रश्न और उत्तर – नए EU कॉपीराइट नियम`)
};

const th_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำถามและคำตอบ – กฎลิขสิทธิ์ใหม่ของสหภาพยุโรป`)
};

const ja_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある質問 – 新しい EU 著作権ルール`)
};

const zh_cn2_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题与解答 – 新的欧盟版权规则`)
};

const zh_hant1_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題與解答 – 新的歐盟版權規則`)
};

const ko_privacy_eudirective21 = /** @type {(inputs: Privacy_Eudirective21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`질문과 답변 – 새로운 EU 저작권 규칙`)
};

/**
* | output |
* | --- |
* | "Questions and Answers – New EU copyright rules" |
*
* @param {Privacy_Eudirective21Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_eudirective21 = /** @type {((inputs?: Privacy_Eudirective21Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Eudirective21Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_eudirective21(inputs)
	if (locale === "ms") return ms_privacy_eudirective21(inputs)
	if (locale === "da") return da_privacy_eudirective21(inputs)
	if (locale === "de") return de_privacy_eudirective21(inputs)
	if (locale === "en-US") return en_us2_privacy_eudirective21(inputs)
	if (locale === "es-ES") return es_es2_privacy_eudirective21(inputs)
	if (locale === "es-MX") return es_mx2_privacy_eudirective21(inputs)
	if (locale === "fil") return fil_privacy_eudirective21(inputs)
	if (locale === "fr") return fr_privacy_eudirective21(inputs)
	if (locale === "it") return it_privacy_eudirective21(inputs)
	if (locale === "hu") return hu_privacy_eudirective21(inputs)
	if (locale === "nl") return nl_privacy_eudirective21(inputs)
	if (locale === "no") return no_privacy_eudirective21(inputs)
	if (locale === "pl") return pl_privacy_eudirective21(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_eudirective21(inputs)
	if (locale === "pt") return pt_privacy_eudirective21(inputs)
	if (locale === "ro") return ro_privacy_eudirective21(inputs)
	if (locale === "fi") return fi_privacy_eudirective21(inputs)
	if (locale === "sv") return sv_privacy_eudirective21(inputs)
	if (locale === "vi") return vi_privacy_eudirective21(inputs)
	if (locale === "tr") return tr_privacy_eudirective21(inputs)
	if (locale === "cs") return cs_privacy_eudirective21(inputs)
	if (locale === "bg") return bg_privacy_eudirective21(inputs)
	if (locale === "ru") return ru_privacy_eudirective21(inputs)
	if (locale === "uk") return uk_privacy_eudirective21(inputs)
	if (locale === "ar") return ar_privacy_eudirective21(inputs)
	if (locale === "hi") return hi_privacy_eudirective21(inputs)
	if (locale === "th") return th_privacy_eudirective21(inputs)
	if (locale === "ja") return ja_privacy_eudirective21(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_eudirective21(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_eudirective21(inputs)
	return ko_privacy_eudirective21(inputs)
});
export { privacy_eudirective21 as "privacy.euDirective2" }